import React from "react";
import PropTypes from "prop-types";
import NotificationItem from "./NotificationItem";
import {DropdownItem} from "reactstrap";

/** This component will list the notification with notification item component */

const NotificationsList = (props) => {
  const {data} = props;

  return (
    <div className="notification-dropdown">
      {data && data.length > 0 ? (
        data.map((item) => {
          return <NotificationItem {...item} key={item.id} />;
        })
      ) : (
        <DropdownItem>No Notifications </DropdownItem>
      )}
    </div>
  );
};

NotificationsList.propTypes = {
  /** List of notification objects which are need to be displayed */
  data: PropTypes.arrayOf(
    PropTypes.shape({
      /** Notification message */
      message: PropTypes.string.isRequired,
      /** Notification created date */
      created_at: PropTypes.string.isRequired,
      /** Notification read status */
      is_read: PropTypes.bool.isRequired,
      /** Notification id */
      id: PropTypes.number.isRequired,
    })
  ).isRequired,
};

export default NotificationsList;
